import { type UseQueryResult, useQuery } from 'react-query';
import { WarrantParticipantService } from '../../services/wealthlane-captable-services';

const useGetWarrantExerciseHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  warrantId: string,
  enabled: boolean = true
): UseQueryResult<any | undefined, unknown> => {
  return useQuery(
    ['getWarrantExerciseHistory', warrantId],
    async () => {
      return await handleRequest(
        WarrantParticipantService.getApiCapTableApiAppWarrantParticipantExerciseHistory(warrantId)
      );
    },
    { enabled: enabled && !!warrantId }
  );
};

export default useGetWarrantExerciseHistory;
